module.exports = __webpack_public_path__ + "img/4.09266420.png";